import { render, staticRenderFns } from "./QuestionToAchive.vue?vue&type=template&id=4a635efb&scoped=true&"
import script from "./QuestionToAchive.vue?vue&type=script&lang=js&"
export * from "./QuestionToAchive.vue?vue&type=script&lang=js&"
import style0 from "./QuestionToAchive.vue?vue&type=style&index=0&id=4a635efb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a635efb",
  null
  
)

export default component.exports